import { RespostaConhecimentoTransporte } from "app/types/pesquisa-orcamento/consultas/ConhecimentoTransporte";
import { BaseApi } from "./BaseApi";

export class ConhecimentoTransportelApi extends BaseApi {
    async ListarConhecimentoTransporte(numeroPedido: number): Promise<RespostaConhecimentoTransporte[]> {
        const resposta = await this.api.post(`/ConhecimentoTransporte/ConhecimentoTransporte`, {
            numeroPedido
        })

        return resposta?.data
    }
}
